var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.99976C19.9231 5.58249 19.7125 4.66416 19.1364 3.96219C18.9702 3.75965 18.7845 3.57394 18.5819 3.40772C17.4756 2.49976 15.8319 2.49976 12.5444 2.49976L12 2.49992C8.22876 2.49992 6.34314 2.49992 5.17157 3.67149C4 4.84307 4 6.72868 4 10.4999V13.4999C4 17.2711 4 19.1568 5.17157 20.3283C6.34314 21.4999 8.22876 21.4999 12 21.4999L12.5444 21.4997C15.8319 21.4997 17.4756 21.4997 18.5819 20.5918C18.7845 20.4256 18.9702 20.2399 19.1364 20.0373C19.7125 19.3353 19.9231 18.417 20 16.9997",
    stroke: "#6A6A6A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 8 20 10.946 20 12C20 13.0541 16 16 16 16M19.5 12H9",
    stroke: "#6A6A6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.1b7fbc6078e0d1981f13b98a53383d52.svg";
export { ForwardRef as ReactComponent };